import { Alert } from '../shadcn'
import { cn } from '../../lib/utils'
import { PropsWithChildren } from 'react'

type AlertColor = 'blue' | 'red' | 'green' | 'gray' | 'amber'

type CalloutProps = PropsWithChildren<{
  color?: AlertColor
  className?: string
}>

export const ColoredAlert = ({ className, color = 'blue', children }: CalloutProps) => {
  return <Alert className={cn('border-none', getColorStyle(color), className)}>{children}</Alert>
}

const getColorStyle = (color: AlertColor) => {
  switch (color) {
    case 'blue':
      return 'bg-blue-3 text-blue-11 [&>svg]:text-blue-11'
    case 'red':
      return 'bg-red-3 text-red-11 [&>svg]:text-red-11'
    case 'green':
      return 'bg-green-3 text-green-11 [&>svg]:text-green-11'
    case 'gray':
      return 'bg-gray-3 text-gray-11 [&>svg]:text-gray-11'
    case 'amber':
      return 'bg-amber-3 text-amber-11 [&>svg]:text-amber-11'
  }
}
